import React from 'react';

interface PrintWrapperProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * PrintWrapper - A reusable component that wraps content with id="search-app"
 * to preserve styles during printing. This is essential for maintaining
 * the application's styling when generating PDFs.
 */
export const PrintWrapper: React.FC<PrintWrapperProps> = ({
  children,
  className = '',
}) => {
  return (
    <div id="search-app" className={className}>
      {children}
    </div>
  );
};
